import moment from 'moment-timezone';
import { DateWithTimezone } from '../app/types';

export function getDateWithTimezone(date: Date, timezone: string): DateWithTimezone {
  return moment(date).tz(timezone) as DateWithTimezone;
}

/**
 * Will return a string with the following format "2pm Feb 5th"
 */
export function getFormattedShortDate(date: moment.Moment) {
  const hours = date.hours();
  const day = date.date();
  const month = date.format('MMM');

  const amPm = hours >= 12 ? 'pm' : 'am';
  // Convert 24-hour format to 12-hour format
  const formattedHour = hours % 12 || 12;

  return `${formattedHour}${amPm} ${month} ${day}`;
}

/**
 * Will return a string with the following format "2 - 3pm"
 */
export function getformattedShortStartEndDate(startDate: DateWithTimezone, endDate: DateWithTimezone) {
  const startHours = startDate.hours();
  const startMinutes = startDate.format('mm');
  const startFormattedHour = startHours % 12 || 12;

  const endHours = endDate.hours();
  const endMinutes = endDate.format('mm');
  const endPeriod = endHours >= 12 ? 'PM' : 'AM';
  const endFormattedHour = endHours % 12 || 12;

  const startMin = startMinutes === '00' ? '' : `:${startMinutes}`;
  const endMin = endMinutes === '00' ? '' : `:${endMinutes}`;

  return `${startFormattedHour}${startMin} - ${endFormattedHour}${endMin} ${endPeriod}`;
}

/**
 * Will return a string with the following format "Jan 7th 2025, 2:30 PM - 4:30 PM"
 */
export function getFormattedShortStartEndDate(startDate: DateWithTimezone, endDate: DateWithTimezone) {
  const year = startDate.year();
  const month = startDate.format('MMM');
  const day = startDate.date();
  const ordinalSuffix = getOrdinalSuffix(day);

  const startHours = startDate.hours();
  const startMinutes = startDate.format('mm')
  const startPeriod = startHours >= 12 ? 'PM' : 'AM';
  const startFormattedHour = startHours % 12 || 12;

  const endHours = endDate.hours();
  const endMinutes = endDate.format('mm')
  const endPeriod = endHours >= 12 ? 'PM' : 'AM';
  const endFormattedHour = endHours % 12 || 12;

  return `${month} ${day}${ordinalSuffix} ${year}, ${startFormattedHour}:${startMinutes} ${startPeriod} - ${endFormattedHour}:${endMinutes} ${endPeriod}`;
}

/**
 * Will return a string with the following format "Jan 1 2025 - Jan 7 2025"
 */
export function getFormattedDateForCalendarTittle(start: Date, end: Date) {
  const startYear = start.getFullYear();
  const startMonth = new Intl.DateTimeFormat('en', { month: 'short' }).format(start);
  const startDay = start.getDate();

  const endYear = end.getFullYear();
  const endMonth = new Intl.DateTimeFormat('en', { month: 'short' }).format(end);
  const endDay = end.getDate();

  return `${startMonth} ${startDay} ${startYear} - ${endMonth} ${endDay} ${endYear}`;
}

function getOrdinalSuffix(day) {
  if (day % 10 === 1 && day % 100 !== 11) return 'st';
  if (day % 10 === 2 && day % 100 !== 12) return 'nd';
  if (day % 10 === 3 && day % 100 !== 13) return 'rd';
  return 'th';
}

// Returns the next weekend day. Ex: Saturday -> Sunday. Sunday -> Next week Saturday
export function getNextWeekendDay(timezone): DateWithTimezone {
  const today = moment().tz(timezone);
  // 0 = Sunday, 6 = Saturday
  const dayOfWeek = today.day();

  let nextWeekendDay: moment.Moment;
  if (dayOfWeek === 6) {
    // Today is Saturday, return Sunday
    nextWeekendDay = today.add(1, 'day');
  } else if (dayOfWeek === 0) {
    // Today is Sunday, return next week's Saturday
    nextWeekendDay = today.add(6, 'days');
  } else {
    // Otherwise, return the next Saturday
    nextWeekendDay = today.day(6);
  }

  return nextWeekendDay as DateWithTimezone;
}
